// Let's the frontend call the backend, since trying to do it with imports leads to an
// "outside of project directory" error
import {create} from "zustand"

export const useResultsStore = create((set) => ({
    results: [],
    createResults: async(newResults) => {
        // Not actually a tencent API, it's ours, just weird naming
        const res = await fetch("/api/tencent", { //host + "/api/tencent", {
            method: "POST",
            headers:{ "Content-Type": "application/json"},
            body: JSON.stringify(newResults),
        })
        const data = await res.json()
        set((state) => ({results: [...state.results, data.data]}))
        return {success: true, message: "Results created!"}
    },
    getResults: async() => {
        // Not needed - redux store is so the frontend can call API endpoints.
        // For now this is just a manual testing endpoint for postman.
    },
    getImage: async() => {
        // Placeholder for same reason as above
    },
    uploadImage: async(image, imageName) => {
        try {
            const imagePayload = {image: image, imageName: imageName}
            
            // Not actually a tencent API, it's ours, just weird naming
            const res = await fetch("/api/tencent/uploadImage", {
                method: "POST",
                headers:{ "Content-Type": "application/json"},
                body: JSON.stringify(imagePayload),
            })
            const data = await res.json()
            set((state) => ({results: [...state.results, data.data]}))

            return {success: true, message: "Image uploaded!"}
        } catch(error) {
            console.log("Error in saving image: ", error.message)
            return {success: false, message: "Uploaded failed with error: " + error.message}
        }
    }
}))